__webpack_require__.p = "/views-candidate/referrals-hub/";